import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import { useTranslation } from 'hooks/useTranslation';
import { OrderSummary } from 'features/dashboard/ts/OrderSummary';
import { GiftOrderSummaryItem, GiftOrderSummaryItemSize } from 'features/dashboard/components/GiftOrderSummaryItem';

import { useStyles } from './styles';

interface GiftOrderSummaryProps {
  summary: OrderSummary[];
  size: GiftOrderSummaryItemSize;
}

export const GiftOrderSummary = ({ summary, size }: GiftOrderSummaryProps) => {
  const { t } = useTranslation('dashboard');
  const classes = useStyles({ size });

  return (
    <Box display="flex" flexDirection="column" alignItems="space-between" className={classes.summaryContainer}>
      {summary?.map((summaryItem, index) => (
        <React.Fragment key={`summary-item-${index}`}>
          {summaryItem.currency?.toLowerCase() !== summary?.[index - 1]?.currency?.toLowerCase() && (
            <Box
              display="flex"
              justifyContent="space-between"
              paddingBottom={size === 'medium' ? 12 : 2}
              className={classes.totalAvailableContainer}
            >
              <Typography>{t('availableBalance')}</Typography>
              <Typography className={classes.totalAvailableAmount}>
                {Number(summaryItem.available).toLocaleString('currency', { maximumFractionDigits: 2 })}{' '}
                {summaryItem.currency}
              </Typography>
            </Box>
          )}
          <GiftOrderSummaryItem size={size} summaryItem={summaryItem} isLast={summary.length - 1 === index} />
        </React.Fragment>
      ))}
    </Box>
  );
};
